import React from "react";
import { logger } from "@lib/common";
import { SelectAsync } from "../../form/select.async";
export class InputAddress extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.loadOptions = async (input) => {
            const { type, gm, mb } = this.props;
            if (type === "osm") {
                try {
                    const result = await mb.geocode_autocomplete(input, {
                        types: "address,poi",
                    });
                    return result.features.map((p) => ({
                        ...p,
                        value: p.place_name,
                        label: p.place_name,
                    }));
                }
                catch (e) {
                    if (!e || e.message !== "Not Found") {
                        logger.captureException(e);
                    }
                    this.props.onError(typeof e === "string" ? e : "Error finding location data");
                    return [];
                }
            }
            else {
                try {
                    const predictions = await gm.autocomplete_place({
                        input: input,
                    });
                    return predictions.map((p) => ({
                        ...p,
                        place_id: p.place_id,
                        value: p.description,
                        label: p.description,
                    })).filter((p) => !!p.place_id);
                }
                catch (e) {
                    if (e !== "Nothing found") {
                        logger.captureException(e);
                    }
                    this.props.onError(typeof e === "string" ? e : "Error finding location data");
                    return [];
                }
            }
        };
        this.onChange = async (value) => {
            const { type, gm } = this.props;
            if (!value) {
                this.props.onError(null);
                return;
            }
            if (type === "osm") {
                value = value;
                const components = {};
                for (const c of value.context) {
                    const key = c.id.split(".")[0];
                    components[key] = c.text;
                }
                this.props.onChange(value.place_name, {
                    type: "osm",
                    components: components,
                    lng: value.center[0],
                    lat: value.center[1],
                });
            }
            else {
                try {
                    value = value;
                    const place = await gm.place_get(value.place_id);
                    if (!place.geometry || !place.address_components || !place.formatted_address) {
                        throw new Error(`Missing geometry for ${value.value}`);
                    }
                    const componentForm = {
                        street_number: "short_name",
                        route: "long_name",
                        locality: "long_name",
                        administrative_area_level_1: "short_name",
                        country: "long_name",
                        postal_code: "short_name",
                    };
                    const components = {};
                    for (const component of place.address_components) {
                        const t = component.types[0];
                        if (componentForm[t]) {
                            components[t] = component[componentForm[t]];
                        }
                    }
                    this.props.onChange(place.formatted_address, {
                        type: "google_maps",
                        components: components,
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng(),
                    });
                }
                catch (e) {
                    logger.captureException(e);
                    this.props.onError(typeof e === "string" ? e : "Error finding data on selected location");
                }
            }
        };
    }
    render() {
        return (React.createElement(SelectAsync, { value: this.props.value, fetch: this.loadOptions, onChange: this.onChange }));
    }
}
//# sourceMappingURL=index.js.map